/* Svensk katalog for locale-no.js (del 9 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'sub.noInvoiceSentText': 'Fakturor som du skickar från detta abonnemang visas här.',
  'sub.invoiceRunFallback': 'Fakturakörning',
  'sub.statusSaved': 'sparad',
  'sub.noEmailSentText': 'E-postmeddelanden som du skickar till kunderna visas här.',
  'sub.emailLogFallback': 'E-postlogg',
  'sub.recipientsCount': '{count} mottagare',
  'sub.changesSaved': 'Ändringarna har sparats',
  'sub.listCreated': 'Listan har skapats',
  'sub.subscriptionCreated': 'Abonnemanget har skapats',
  'sub.saveError': 'Det gick inte att spara.',
  'sub.customersSaved': 'Kunderna har sparats',
  'sub.saveCustomersError': 'Det gick inte att spara kunderna.',
  'sub.agreementResumed': 'Avtalet är aktivt igen',
  'sub.agreementPaused': 'Avtalet är pausat',
  'sub.updateAgreementError': 'Det gick inte att uppdatera avtalet.',
  'sub.listDeleted': 'Listan har tagits bort',
  'sub.subscriptionDeleted': 'Abonnemanget har tagits bort',
  'sub.deleteError': 'Det gick inte att ta bort.',
  'sub.emailsSentToast': '{count} e-postmeddelanden skickade',
  'sub.emailsSentFailedSuffix': ', {count} inte skickade',
  'sub.sendEmailError': 'Det gick inte att skicka e-post.',
  'sub.searchSubPlaceholder': 'Sök efter abonnemang, kund eller belopp...',
  'sub.searchListPlaceholder': 'Sök efter lista eller kund...',
  'sub.emptySubTitle': 'Inga abonnemang ännu',
  'sub.emptyListTitle': 'Inga listor ännu',
  'sub.emptySubText': 'Skapa ditt första abonnemang för att fakturera kunder regelbundet.',
  'sub.emptyListText': 'Skapa din första kundlista.',
  'sub.preservedSubscriptionsNotice': '{count} äldre kundabonnemang finns kvar i app-state och kan migreras senare.',
  'agreements.customer': 'Kund',
  'agreements.tab.subscriptions': 'Abonnemang',
  'agreements.tab.recurring': 'Återkommande',
  'agreements.tab.lists': 'Listor',
  'agreements.unknownCustomer': 'Okänd kund',
  'agreements.recurringInvoice': 'Återkommande faktura',
  'agreements.lastSent': 'Senast skickad',
  'agreements.nextDelivery': 'Nästa utskick',
  'agreements.net': 'Netto',
  'agreements.amount': 'Belopp',
  'agreements.total': 'Totalt',
  'agreements.status': 'Status',
  'agreements.status.active': 'Aktiv',
  'agreements.status.paused': 'Pausad',
  'agreements.status.ended': 'Avslutad',
  'agreements.status.failed': 'Misslyckad',
  'agreements.pause': 'Pausa',
  'agreements.resume': 'Återuppta',
  'agreements.interval': 'Intervall',
  'agreements.interval.weekly': 'Varje vecka',
  'agreements.interval.fourteen_days': 'Var 14:e dag',
  'agreements.interval.monthly': 'Varje månad',
  'agreements.interval.quarterly': 'Varje kvartal',
  'agreements.interval.semiannual': 'Varje halvår',
  'agreements.interval.annual': 'Varje år',
  'agreements.paymentTerms': 'Betalningsfrist',
  'agreements.days': '{count} dagar',
  'agreements.units': 'st.',
  'agreements.invoiceLine': 'Fakturarad',
  'agreements.deliveries': 'Utskick',
  'agreements.noDeliveries': 'Inga automatiska utskick ännu.',
  'agreements.invoice': 'Faktura',
  'agreements.sent': 'Skickad',
  'agreements.processing': 'Behandlas',
  'agreements.emptyTitle': 'Inga återkommande fakturor',
  'agreements.emptyText': 'Slå på Återkommande när du skapar en faktura. Serien visas här och kan pausas när som helst.',
  'agreements.autoSend': 'Automatiskt utskick',
  'agreements.autoSendHelp': 'Plumme skapar och skickar faktura på nästa fakturadatum. Kan pausas från Avtal.',
  'agreements.newRecurring': 'Ny återkommande',
  'agreements.newRecurringTitle': 'Ny återkommande faktura',
  'agreements.searchRecurring': 'Sök efter kund, avtal eller belopp...',
  'agreements.sortBy': 'Sortera efter {column}',
  'rep.help': 'Hjälp',
  'rep.excel': 'Excel',
  'rep.allAccountsSub': 'Alla konton i kontoplanen för vald period.',
  'rep.openingChangeClosing': 'Ingående / Förändring / Utgående',
  'rep.balanceModeHelp': 'Välj vilket saldo som visas. Ingående är saldot vid periodens början, Förändring är rörelsen under perioden och Utgående är saldot vid slutet. Utgående = ingående + förändring.',
  'rep.groupsHelp': 'Kontona är indelade i grupper efter första siffran: tillgångar (1xxx), eget kapital och skulder (2xxx), intäkter (3xxx) och kostnader (4xxx–7xxx). Tryck för att dölja eller visa gruppen.',
  'rep.displayHelp': 'Visa konto slår på eller av kontonumret framför varje rad. Visa som väljer om beloppen visas i kronor och ören, hela kronor eller hela tusental.',
  'rep.showAccount': 'Visa konto',
  'rep.showAs': 'Visa som',
  'rep.operatingIncomeHelp': 'Summan av det som företaget har tjänat på den ordinarie verksamheten under vald period.',
  'rep.operatingCostHelp': 'Summan av kostnaderna för att driva verksamheten under vald period.',
  'rep.resultHelp': 'Rörelseintäkter minus rörelsekostnader och finansiella poster. Positivt tal är överskott, negativt är underskott.',
  'rep.groupHelp': 'En huvudgrupp i resultaträkningen. Tryck för att öppna eller stänga gruppen och se kontona bakom summan.',
  'rep.noLedgerLines': 'Inga huvudboksrader tillgängliga från backend.',
  'bwf.fixPostedEntry': 'Korrigera kontering',
  'bwf.createsDiscrepancy': 'Skapar avvikelse',
  'bwf.entry': 'Kontering',
  'bwf.whatToDo': 'Vad vill du göra?',
  'bwf.correctPostedAmount': 'Rätt bokfört belopp',
  'bwf.correctDate': 'Rätt datum',
  'bwf.postedEntry': 'Bokförd post',
  'bwf.matched': 'Matchad',
  'bwf.plummaLinks': 'SuperPlumma kopplar',
  'bwf.searchInbox': 'Sök på verifikation eller belopp…',
  'bwf.clickForPreview': 'Klicka för förhandsgranskning, eller dra verifikationen till en bankrad',
  'bwf.tapToPick': 'Tryck för att välja verifikationen och tryck sedan på bankraden',
  'bwf.tapHint': 'Tryck på en verifikation · välj sedan bankraden den hör till',
  'bwf.pickedVoucher': 'Vald verifikation',
  'bwf.pickTapLine': 'Tryck på bankraden som verifikationen hör till.',
  'bwf.cancelPick': 'Avbryt',
  'bwf.pickChooseLine': 'Välj bankraden som verifikationen hör till',
  'bwf.possibleMatch': 'Möjlig matchning',
  'bwf.previewVoucher': 'Förhandsgranska verifikation',
  'bwf.annulEntry': 'Makulera konteringen',
  'bwf.correctEntry': 'Korrigera kontering',
  'bwf.account': 'Konto',
  'bwf.missing': 'saknas',
  'bwf.searchAccount': 'Sök konto …',
  'bwf.noAccountHits': 'Inga träffar',
  'bwf.selectedLines': 'rader valda',
  'bwf.selectedLinesHelp': 'Välj vad som ska göras med de valda raderna.',
  'bwf.clearSelection': 'Rensa val',
  'bwf.bulkProcessing': 'Behandlar rad {{index}} av {{total}}',
  'bwf.andNext': 'och nästa',
  'bwf.andLast': 'sista',
  'bwf.openInbox': 'Öppna inkorgen',
  'bwf.drawerHint': 'Tryck på en verifikation och sedan på bankraden — eller dra ut den på raden.',
  'bwf.selectLine': 'Välj bankrad',
  'bwf.selectLineHelp': 'Markera bankrader för att behandla flera samtidigt. Skift-klick markerar ett intervall. Färgen visar fortfarande radens status.',
  'onb.getStartedTitle': 'Kom igång med Plumme',
  'onb.getStarted': 'Kom igång',
  'onb.whatCreate': 'Vad vill du skapa?',
  'onb.whatCreateHelp': 'Välj vad du vill ställa in nu. Du kan alltid lägga till mer senare.',
  'onb.registerCompany': 'Registrera ett bolag för fakturering, bokföring och moms.',
  'onb.backendComing': 'En egen backend-modell behövs innan detta kan aktiveras.',
  'onb.createPersonal': 'Skapa din privatekonomi',
  'onb.createPersonalHelp': 'Detta skapar en separat privatekonomianvändare som du hittar via Min sida och användarväljaren.',
  'onb.welcome': 'Välkommen',
  'onb.letsSetUp': 'Nu ställer vi in ditt företag',
  'onb.tellUsAbout': 'Berätta om företaget',
  'onb.signedIn': 'Inloggad',
  'onb.sweden': 'Sverige',
  'onb.denmark': 'Danmark',
  'onb.companyNamePh': 'T.ex. Joda Consulting AS',
  'onb.nineDigits': '9 siffror',
  'onb.resetAndSearch': 'Rensa och sök igen',
  'onb.checkingExisting': 'Kontrollerar om företaget redan finns i Plumme...',
  'onb.searchingRegistry': 'Söker i Brønnøysundregistrene...',
  'onb.companyForm': 'Företagsform',
  'onb.searchingAddress': 'Söker efter adress...',
  'onb.oslo': 'Oslo',
  'onb.whichPages': 'Vilka sidor vill du använda?',
  'onb.menuNotLoaded': 'Sidomenyn har inte lästs in ännu. Alla standardsidor blir synliga.',
  'onb.bankLater': 'Bankanslutning kommer senare',
  'onb.connectWith': 'Anslut med',
  'onb.noBankData': 'Bankanslutning är inte aktiv ännu. Du kan ladda upp kontoutdrag manuellt när du vill.',
  'onb.allSet': 'Allt klart',
  'onb.allSetHelp': 'Företaget har skapats i backend, lagts till bland dina företag och valts som aktivt företag.',
  'onb.goToPlumme': 'Gå till Plumme',
  'air.sub': 'Visa, jämför, skriv ut och ladda ner månads- och årsrapporter för företaget',
  'air.help': 'Här skapar du månads- och årsrapporter för företaget. Välj period och eventuellt ett år att jämföra med, så uppdateras nyckeltalen, diagrammet och kostnadstabellen automatiskt. Du kan skriva ut rapporten eller ladda ner den som PDF.',
  'air.downloadPdf': 'Ladda ner PDF',
  'air.chooseWhatToShow': 'Välj vad rapporten ska visa',
  'air.chooseHelp': '”Visning” växlar mellan en månad och hela året. ”År” väljer vilket år du tittar på. ”Jämför med” lägger ett tidigare år bredvid, så att alla siffror också visar förändringen mot samma period det året.',
  'air.keyFigures': 'Nyckeltal för perioden',
  'air.keyFiguresHelp': 'De fyra viktigaste siffrorna för vald period: intäkter, kostnader, resultat (intäkter minus kostnader) och resultatmarginal (resultat i procent av intäkterna). Är jämförelse påslagen visar pilen och texten under varje siffra förändringen mot året innan.',
  'air.profitMargin': 'Resultatmarginal',
  'air.chartHelp': 'Stapeldiagrammet visar intäkter (grönt) och kostnader (lila) för varje månad under året, så att du snabbt ser säsongsvariationer och månader där kostnaderna närmar sig intäkterna. I månadsvy framhävs den månad du har valt.',
  'air.costsByCategory': 'Kostnader fördelade per kategori',
  'air.costsByCategoryHelp': 'Tabellen bryter ner de samlade kostnaderna per kategori — lön, hyra, marknadsföring och så vidare. Är jämförelse påslagen ser du fjolårets siffror och förändringen i procent, där rött betyder ökade kostnader och grönt betyder lägre.',
  'air.costCategory': 'Kostnadskategori',
  'pdf.cannotShow': 'Kan inte visa PDF här',
  'pdf.browserBlocked': 'Webbläsaren blockerade visningen.',
  'pdf.rotate': 'Rotera',
  'tf.subsistenceQuestion': 'Ska traktamente beräknas för den här resan?',
  'tf.accommodationQuestion': 'Övernattade du under den här resan?',
  'tf.pickEmployee': 'Välj anställd',
  'tf.timeFrom': 'Tidpunkt från',
  'tf.timeTo': 'Tidpunkt till',
  'tf.mealsCovered': 'Vilka måltider bekostades av andra?',
  'hh.household': 'Hushåll',
  'hh.help': 'Koppla ihop två separata Privatekonomi-konton. Egna konton och transaktioner förblir privata; bara uppgifter som sparas under Familj delas.',
  'hh.privacyNote': 'Privata konton, transaktioner, skatt och personliga planer delas inte automatiskt.',
  'hh.partnerEmail': 'Partnerns e-post',
  'hh.partnerEmailPh': 'partner@exempel.se',
  'hh.invitesForYou': 'Inbjudningar till dig',
  'hh.wantsToLink': 'Vill koppla ihop Privatekonomi-kontona som ett hushåll',
  'hh.decline': 'Avböj',
  'hh.accept': 'Godkänn',
  'hh.pendingInvites': 'Väntande inbjudningar',
  'hh.awaitingReply': 'Väntar på svar',
  'srch.placeholder': 'Sök bland kunder, fakturor, produkter, verifikationer, projekt …',
  'srch.esc': 'esc',
  'srch.recent': 'Senaste sökningar',
  'srch.noMatches': 'Inga träffar på ”{query}”.',
  'srch.tryPageName': 'Prova ett namn, nummer, belopp, sidnamn eller hjälpämne.',
  'srch.group.customers': 'Kunder',
  'srch.group.suppliers': 'Leverantörer',
  'srch.group.products': 'Produkter',
  'srch.group.sales': 'Försäljning och fakturor',
  'srch.group.vouchers': 'Köp och verifikationer',
  'srch.group.documents': 'Dokument och inkorg',
  'srch.group.projects': 'Projekt och timmar',
  'srch.group.other': 'Annat i bokföringen',
  'srch.tag.customer': 'Kund',
  'srch.tag.supplier': 'Leverantör',
  'srch.tag.product': 'Produkt',
  'srch.tag.invoice': 'Försäljningsdokument',
  'srch.tag.expense': 'Köp',
  'srch.tag.other-sale': 'Annan försäljning',
  'srch.tag.receipt': 'Inkorg',
  'srch.tag.project': 'Projekt',
  'srch.tag.activity': 'Aktivitet',
  'srch.tag.mileage': 'Körjournal',
  'srch.tag.agreement': 'Avtal',
  'srch.tag.company-document': 'Dokument',
  'srch.tag.bank-statement': 'Kontoutdrag',
  'srch.recentDefaults': 'faktura|lön|moms',
  'srch.group.shortcuts': 'Genvägar',
  'srch.nav.sub': 'Sida i Plumme',
  'srch.help.sub': 'Hjälpartikel',
  'srch.hint.browse': 'bläddra',
  'srch.hint.open': 'öppna',
  'srch.hint.close': 'stäng',
  'srch.countShown': '{count} träffar visas',
  'srch.fallback.trip': 'Körning',
  'srch.kind.offer': 'Offert',
  'srch.kind.invoice': 'Faktura',
  'srch.kind.invoiceDraft': 'Fakturautkast',
  'srch.kind.orderConfirmation': 'Orderbekräftelse',
  'srch.kind.sale': 'Försäljning',
  'srch.kind.customerList': 'Kundlista',
  'hlp.explainMode': 'Förklara för mig – tryck, och tryck sedan på det du undrar över (genväg: ? eller Ctrl+I)',
  'hlp.helpModeOn': 'Hjälpläget är på.',
  'hlp.tapWhatever': 'Tryck på det du undrar över, så förklarar vi det.',
  'hlp.shortcutHint': 'Tryck ? eller Ctrl+I för att slå av/på.',
  'hlp.exit': 'Avsluta',
  'sd.deleteAllCustomers': 'Ta bort alla kunder',
  'sd.deleteAllSuppliers': 'Ta bort alla leverantörer',
  'sd.deleteAllProducts': 'Ta bort alla produkter',
  'sd.exportLedger': 'Exportera huvudbok',
  'sd.importLedger': 'Importera huvudbok',
  'sd.exportDetails': 'Exportera detaljer',
  'sd.importDetails': 'Importera detaljer',
  'sd.exportVouchers': 'Exportera verifikationer',
  'sd.importVouchers': 'Importera verifikationer',
  'sd.deleteBusinessHelp': 'Ta bort företag tar bort det valda företaget efter 30 dagar via backend. Detta är en allvarlig åtgärd.',
  'sd.permissionsHelp': 'Bara ägare eller admin kan återställa data och tömma register. Bara ägaren kan ta bort företaget.',
  'ha.h6.title': 'Så lämnar du in MVA-meldingen',
  'ha.cat.vat': 'Moms och avgifter',
  'ha.read3': '3 min läsning',
  'ha.h6.lead': 'MVA-meldingen visar hur mycket moms företaget har tagit ut på försäljning och betalat på inköp under en period. Plumme räknar ut siffrorna automatiskt från bokförda verifikationer — du kontrollerar dem och lämnar in deklarationen hos Skatteetaten. Så här gör du.',
  'ha.h6.before': 'Innan du börjar',
  'ha.h6.beforeText': 'Se till att alla inköp och all försäljning under perioden är bokförda och att inkorgen är tom. Siffrorna i deklarationen hämtas direkt från bokföringen, så det som inte är bokfört kommer inte heller med i deklarationen.',
  'ha.h6.reminded': 'Du blir påmind i god tid',
  'ha.h6.remindedText': 'Plumme påminner dig automatiskt om fristen. Du hittar alltid nästa frist på startsidan och under Inlämningar.',
  'ha.h6.openPeriod': 'Öppna rätt period',
  'ha.h6.openPeriodText': 'Gå till Inlämningar → MVA-melding. Perioderna som kräver åtgärd ligger överst. Tryck på ”Öppna deklaration” för perioden du ska lämna in.',
  'ha.h6.fig1': 'Periodöversikten. ”3. termin 2026” kräver åtgärd och har frist 31 augusti.',
  'ha.h6.check': 'Kontrollera beräkningen',
  'ha.h6.checkText': 'Överst ser du utgående moms (det du har tagit ut på försäljning) minus ingående moms (det du har betalat på inköp). Skillnaden är antingen att betala eller att återfå. I det här exemplet ska 49 834 kr återfås.',
  'ha.h6.fig2': 'Utgående minus ingående moms ger beloppet du ska betala eller få tillbaka.',
  'ha.h6.codes': 'Gå igenom kodöversikten',
  'ha.h6.codesText': 'Kodöversikten visar hur underlaget fördelar sig på de olika momskoderna — försäljning, inköp och import. Tryck på en kod för att se vilka verifikationer som ligger bakom siffran. Stämmer allt trycker du på ”Kontrollera siffrorna”.',
  'ha.h6.fig3': 'Varje rad visar underlag, sats och moms per kod. Tryck på en kod för att se verifikationerna bakom.',
  'ha.h6.deviation': 'Kontrollera avvikelser innan du skickar',
  'ha.h6.deviationText': 'Får du ett belopp som du inte känner igen bör du gå igenom bokföringen före inlämning. Det är enklare att rätta till innan deklarationen är skickad än efteråt.',
  'ha.h6.send': 'Lämna in deklarationen hos Skatteetaten',
  'ha.h6.sendText': 'Plumme kan inte skicka MVA-meldingen till Skatteetaten. För in siffrorna från Plumme och lämna in deklarationen i Skatteetatens tjänst, och spara kvittensen. Gå sedan tillbaka till perioden i Plumme och tryck på ”Markera som inlämnad utanför Plumme”. Ange datumet du lämnade in och gärna referensen från kvittensen. Då låses verifikationerna i perioden, och perioden räknas som inlämnad i bokslutet.',
  'ha.h6.after': 'Efter inlämning',
  'ha.h6.afterText': 'Ska du betala hittar du KID och kontonummer på kvittensen från Skatteetaten. När perioden är markerad som inlämnad utanför Plumme och beloppet är betalt eller återbetalt registrerar du avräkningen på perioden med ”Registrera betalning” eller ”Registrera återbetalning”, så stämmer bokföringen med skattekontot.',
  'ha.h12.title': 'Så skapar du en faktura',
  'ha.cat.sales': 'Försäljning och faktura',
  'ha.h12.lead': 'Med Ny försäljning skapar du en faktura till en kund i några få steg. Du väljer kund, fyller i raderna och ser en levande förhandsgranskning innan du skapar och skickar. Försäljningen bokförs automatiskt.',
  'ha.h12.beforeText': 'Det är en fördel att ha kunden och produkterna sparade sedan tidigare, men du kan också skriva in både mottagare och rader som fritext under tiden. Allt kan ändras innan du skapar fakturan.',
  'ha.h12.open': 'Öppna Ny försäljning och välj faktura',
  'ha.h12.openText': 'Gå till Ny försäljning i menyn. Överst väljer du dokumenttyp — välj ”Faktura”. Du kan också skapa offert eller orderbekräftelse härifrån.',
  'ha.h12.quoteOrder': 'Offert och orderbekräftelse',
  'ha.h12.quoteOrderText': 'Samma tillvägagångssätt gäller för offert och orderbekräftelse — välj bara rätt typ i ”Ny faktura”-menyn överst, så är stegen och fälten desamma. ”Annan försäljning” är lite annorlunda: där laddar du upp en verifikation som dokumentation i stället för att välja kund.',
  'ha.h12.customerText': 'I steget ”Kund” söker du fram en sparad kund, lista eller ett abonnemang — eller tryck på ”Ny kund” för att ange en mottagare som inte är sparad. Namn och adress hämtas automatiskt in i dokumentet.',
  'ha.h12.fig1': 'Steg 1 ”Kund”: sök fram en sparad kund, lista eller ett abonnemang — eller skapa en ny mottagare.',
  'ha.h12.details': 'Fyll i detaljer',
  'ha.h12.detailsText': 'Under ”Detaljer” anger du fakturadatum och förfallodatum samt eventuella referenser. Vill du att fakturan ska skickas automatiskt varje period slår du på ”Återkommande”.',
  'ha.h12.fig2': 'Steg 2 ”Detaljer”: fakturadatum, förfallodatum och referenser. Slå på ”Återkommande” för automatiskt utskick.',
  'ha.h12.lines': 'Lägg till rader',
  'ha.h12.linesText': 'I steget ”Rader” lägger du till det du säljer. Välj en sparad produkt eller skriv fritext och ange antal, pris och momssats. Radsumman räknas ut automatiskt.',
  'ha.h12.fig3': 'Steg 3 ”Rader”: varje rad har antal, pris och momssats. Radsumma och totalsumma räknas ut åt dig.',
  'ha.h12.livePreview': 'Direkt förhandsgranskning',
  'ha.h12.livePreviewText': 'Bredvid formuläret ser du hela tiden hur det färdiga dokumentet blir för kunden. Använd ”Byt till allt på en sida” om du hellre vill se alla fält samtidigt.',
  'ha.h12.preview': 'Förhandsgranska och skapa',
  'ha.h12.previewText': 'I ”Förhandsgranskning” kontrollerar du avsändare, kunduppgifter, rader och totalsumma. Stämmer allt skapar du fakturan — och kan skicka den till kunden via e-post eller ladda ned den som PDF.',
  'ha.h12.fig4': 'Steg 4 ”Förhandsgranskning”: kontrollera dokumentet och totalsumman innan du skapar fakturan.',
  'ha.h12.afterText': 'När fakturan har skapats bokförs försäljningen automatiskt på rätt konto, och du hittar den i Fakturalistan med status och förfallodag.',
  'ha.h13.title': 'Registrera annan försäljning',
  'ha.read2': '2 min läsning',
  'ha.h13.lead': 'Annan försäljning är för försäljning som inte behöver en vanlig faktura — som kontantförsäljning, uttag eller försäljning gjord utanför Plumme. Du väljer ”Annan försäljning” i Ny försäljning, laddar upp en verifikation som dokumentation, fyller i belopp och moms och väljer var pengarna kom in. Försäljningen bokförs automatiskt.',
  'ha.h13.when': 'När använder du annan försäljning?',
  'ha.h13.whenText': 'Använd annan försäljning när du inte ska skicka en faktura till en kund — till exempel kontantförsäljning, privat uttag av varor eller en försäljning som redan har gjorts utanför systemet och bara ska bokföras. Ska kunden faktureras skapar du en faktura i stället.',
  'ha.h13.choose': 'Välj Annan försäljning',
  'ha.h13.chooseText': 'Gå till Ny försäljning och välj ”Annan försäljning” i dokumenttypsmenyn högst upp. Flödet får då ett eget ”Verifikation”-steg först.',
  'ha.h13.receiptText': 'I ”Verifikation”-steget laddar du upp en bild eller en PDF som dokumentation av försäljningen — till exempel ett kvitto eller en försäljningsanteckning.',
  'ha.h13.details': 'Fyll i detaljer och ”Betalt till”',
  'ha.h13.detailsText': 'Under ”Detaljer” anger du datum och väljer ”Betalt till” — var pengarna kom in: Företagskonto, Kontant eller Privat. Valet styr vilket konto försäljningen bokförs mot (bank, kassa eller privatuttag).',
  'ha.h13.fig1': 'I ”Detaljer” väljer du ”Betalt till” — Företagskonto, Kontant eller Privat. Det avgör vilket konto försäljningen bokförs mot.',
  'ha.h13.linesText': 'I ”Rader” lägger du till det du sålde, med antal, pris och momssats. Summa och moms räknas ut automatiskt.',
  'ha.h13.fig2': 'Lägg till försäljningsrader med belopp och momssats. Summan räknas ut åt dig.',
  'ha.h13.register': 'Registrera försäljningen',
  'ha.h13.registerText': 'Kontrollera sammanfattningen och tryck på ”Registrera försäljning”. Försäljningen bokförs och verifikationen arkiveras under Transaktioner.',
  'ha.h13.invoiceOrOther': 'Faktura eller annan försäljning?',
  'ha.h13.invoiceOrOtherText': 'Ska du kräva betalning av en kund, skapa en faktura (Ny försäljning → Faktura). Annan försäljning är för försäljning som redan är reglerad eller inte behöver ett betalningskrav.',
  'ha.h1.title': 'Skapa en återkommande faktura',
  'ha.h1.lead': 'En återkommande faktura skickas automatiskt med jämna mellanrum — perfekt för abonnemang och fasta tjänster. Du ställer in den en gång, så sköter Plumme resten.',
  'ha.h1.start': 'Starta en ny faktura',
  'ha.h1.startText': 'Gå till Ny försäljning och fyll i kund och fakturarader som vanligt.',
  'ha.h1.turnOn': 'Slå på ”Återkommande”',
  'ha.h1.turnOnText': 'Under Detaljer slår du på ”Återkommande”. Välj hur ofta fakturan ska skickas (varje vecka, var 14:e dag, månad, kvartal eller år) och när den förfaller.',
  'ha.h1.fig1': 'Slå på ”Återkommande” i steget Detaljer. Då väljer du ”Skickas varje” (intervall) och ”Förfallodag”.',
  'ha.h1.autoText': 'Plumme skapar och skickar automatiskt en ny faktura via e-post varje period. Under Avtal → Återkommande ser du när nästa faktura skickas och kan pausa och återuppta den.',
  'ha.h1.control': 'Pausa i tid',
  'ha.h1.controlText': 'Fakturan skickas utan förvarning. Om något har ändrats pausar du den under Avtal → Återkommande före fakturadatumet. Kunden måste ha en e-postadress, annars skickas ingen faktura.',
  'ha.h2.title': 'Betalningen stämmer inte med fakturan',
  'ha.h2.lead': 'När ett inbetalt belopp skiljer sig från fakturabeloppet registrerar du det belopp som faktiskt har kommit in — så håller Plumme koll på vad som återstår.',
  'ha.h2.open': 'Öppna fakturan',
  'ha.h2.openText': 'Hitta fakturan i Fakturalistan och öppna den. Under ”Betalningsstatus” ser du om den är betald, delvis betald eller obetald.',
  'ha.h2.fig1': '”Betalningsstatus” på fakturan: vad som är betalt, vad som återstår och knappen ”Registrera betalning”.',
  'ha.h2.registerText': 'Tryck på ”Registrera betalning” och ange beloppet som har kommit in. Om beloppet är mindre än fakturan står den kvar som ”Delvis betald”, och återstående belopp visas.',
  'ha.h2.fig2': 'I ”Registrera betalning” anger du beloppet som har kommit in. Återstående belopp visas, och ”Reglerad utan betalning” avslutar resten utan inbetalning.',
  'ha.h2.handle': 'Hantera det som återstår',
  'ha.h2.handleText': 'Kommer resten senare registrerar du en ny betalning då. Ska du avsluta fakturan utan att resten betalas väljer du ”Reglerad utan betalning”. En registrerad betalning kan återföras, och hela betalningen kan nollställas om du har bokfört fel.',
  'ha.h2.autoStatus': 'Status beräknas automatiskt',
  'ha.h2.autoStatusText': 'Betald / delvis betald / obetald räknas ut från de registrerade betalningarna mot fakturabeloppet — du behöver inte ange status själv.',
  'ha.cat.payroll': 'Lön och anställda',
  'ha.cat.purchase': 'Inköp och verifikationer',
  'ha.cat.bank': 'Bank och betalning',
  'ha.cat.assets': 'Tillgångar',
  'ha.cat.budget': 'Budget',
  'ha.cat.closing': 'Bokslut',
  'ha.h9.title': 'Registrera en tillgång och avskrivning',
  'ha.h9.lead': 'Större saker som företaget köper och använder i flera år — som en dator, ett fordon eller maskiner — förs som tillgångar (anläggningstillgångar). I stället för att kostnadsföras direkt skrivs de av lite varje år. Plumme håller reda på avskrivningen åt dig.',
  'ha.h9.whenAsset': 'När är något en tillgång?',
  'ha.h9.whenAssetText': 'Ett köp måste normalt skrivas av när en inventarie har ett anskaffningsvärde på minst 30 000 kr och en förväntad användningstid på minst tre år. Gränsen bedöms per inventarie, inte utifrån fakturasumman ensam.',
  'ha.h9.limit': '30 000-gränsen',
  'ha.h9.limitText': 'Om den enskilda inventarien kostar under 30 000 kr kan anskaffningsvärdet normalt kostnadsföras direkt samma år. Fysiskt eller funktionellt integrerade delar kan behöva bedömas tillsammans.',
  'ha.h9.register': 'Registrera tillgången',
  'ha.h9.registerText': 'Gå till Inköp → Tillgångar och tryck på «Ny tillgång» — eller registrera den direkt från inköpet. Ge den ett namn och ange anskaffningsvärde och anskaffningsdatum.',
  'ha.h9.group': 'Välj saldogrupp',
  'ha.h9.groupText': 'Välj vilken grupp tillgången hör till (t.ex. grupp a för datorutrustning, c för skåpbilar, d för maskiner och inventarier). Gruppen bestämmer avskrivningssatsen.',
  'ha.h9.depreciate': 'Låt Plumme skriva av',
  'ha.h9.depreciateText': 'Varje år beräknas avskrivningen automatiskt som en fast procent av återstående värde (saldometoden). Du ser bokfört värde och samlad avskrivning i anläggningsregistret.',
  'ha.h9.sell': 'När du säljer eller gör dig av med tillgången',
  'ha.h9.sellText': 'Om du säljer tillgången registrerar du försäljningssumman på den. Vinst eller förlust mot bokfört värde hanteras automatiskt — eventuellt via ett vinst- och förlustkonto som fördelar beloppet över flera år.',
  'ha.h10.title': 'Skapa en budget för året',
  'ha.h10.lead': 'En budget är en plan för dina intäkter och kostnader under året. När du har lagt in den jämför Plumme budgeten med de faktiska siffrorna löpande, så att du ser om du ligger i fas med planen.',
  'ha.h10.method': 'Välj metod',
  'ha.h10.methodText': 'Gå till Budget och välj hur du vill börja: med «Manuellt» lägger du in allt själv, med «Förslag» svarar du på några enkla frågor och med «AI-förslag» beskriver du verksamheten med egna ord så skapar Plumme ett utkast.',
  'ha.h10.amounts': 'Lägg in intäkter och kostnader',
  'ha.h10.amountsText': 'Under «Budget per kategori» lägger du till en intäkts- eller kostnadskategori med ett årsbelopp. Beloppet fördelas på månader, som du kan justera om aktiviteten varierar under året.',
  'ha.h10.variance': 'Följ upp avvikelser',
  'ha.h10.varianceText': 'I «Analys» och «Översikt» ser du budget mot faktiskt resultat, månad för månad. Avvikelsen visar om du ligger över eller under planen och vilket konto som avviker mest.',
  'ha.h10.startSimple': 'Börja enkelt',
  'ha.h10.startSimpleText': 'Du behöver inte budgetera allt. Börja med de största intäkterna och kostnaderna — du kan alltid lägga till fler kategorier senare.',
  'ha.h11.title': 'Avsluta räkenskapsåret',
  'ha.h11.lead': 'Bokslutet stänger räkenskapsåret. Du kontrollerar att allt är rätt bokfört, låser året och förbereder sedan skattemelding och årsredovisning. Plumme guidar dig genom varje steg.',
  'ha.h11.before': 'Innan du avslutar',
  'ha.h11.beforeText': 'Se till att alla verifikationer är bokförda, att inkorgen är tom och att momsperioderna är redovisade. Ju mer som är på plats, desto smidigare går bokslutet.',
  'ha.h11.checklist': 'Gå igenom checklistan',
  'ha.h11.checklistText': 'Välj «Gå igenom checklistan». Plumme kontrollerar punkter som bankavstämning, moms, lön och tillgångar. Punkter som kräver åtgärd måste lösas innan året kan stängas.',
  'ha.h11.closeYear': 'Avsluta året',
  'ha.h11.closeYearText': 'När allt är kontrollerat avslutar du räkenskapsåret. Året låses för ändringar — men du kan alltid öppna det igen om något behöver rättas.',
  'ha.h11.taxReturn': 'Förbered skattemeldingen',
  'ha.h11.taxReturnText': 'Plumme skapar ett utkast till skattemeldingen utifrån bokföringen. Gå igenom utkastet och kontrollera siffrorna. Själva skattemeldingen lämnar du hos Skatteetaten, utanför Plumme, och markerar den som inlämnad här.',
  'ha.h11.annualAccounts': 'Upprätta årsredovisningen',
  'ha.h11.annualAccountsText': 'Till sist upprättas årsredovisningen utifrån siffrorna och dokumenten signeras. Årsredovisningen lämnar du till Regnskapsregisteret i Altinn, utanför Plumme (gäller redovisningsskyldiga).',
  'ha.h11.reconciled': 'Bankavstämda perioder',
  'ha.h11.reconciledText': 'Verifikationer i en bankavstämd period kan inte ändras utan att perioden öppnas igen. Det säkerställer att avstämningen förblir korrekt.',
  'ha.h1.save': 'Spara',
  'ha.h2.register': 'Registrera betalning',
  'ha.h12.customer': 'Välj kund',
  'ha.h13.receipt': 'Ladda upp verifikation',
  'ha.eyebrow': 'Hjälp · {category}',
  'ha.readOn': 'Hjälp · läs vidare',
  'ha.backToSearch': 'Tillbaka till sökningen',
  'ha.goTo': 'Gå till {page}',
  'ha.openedInBackground': 'Öppnade {page} i bakgrunden',
  'ha.reopen': 'Öppna hjälpartikeln igen',
  'ha.closeArticle': 'Stäng hjälpartikel',
  'ha.expandImage': 'Öppna bilden i full storlek',
  'ha.collapseImage': 'Minimera bilden',
  'ha.minimize': 'Minimera',
  'ha.minimizeHelp': 'Minimera — ta fram den igen senare',
});
